import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as toastrReducer } from 'react-redux-toastr';

import { reducer as user } from './userDuck';
import { reducer as cockpit } from './cockpitDuck';

import protocoloEnvio from './protocolo/envio';
import protocoloBusca from './protocolo/busca';
import menuProtocolo from './protocolo/menu';
import protocoloExcluir from './protocolo/excluir';
import visualizarProtocolo from './protocolo/visualizar';
import recepcaoContratos from './protocolo/recepcao_contrato';
import recepcaoReducer from './protocolo/recepcao/recepcionar';
import cadastrarCaixaReducer from './protocolo/recepcao/cadastrarcaixa';
import usuariosPreparacao from './protocolo/usuarios_preparacao';

export { UserTypes, userActions } from './userDuck';
export { CockpitTypes, cockpitActions } from './cockpitDuck';
export { FormTypes, formsActions } from './formsDuck';

export default combineReducers({
  protocoloEnvio,
  protocoloBusca,
  recepcaoReducer,
  menuProtocolo,
  protocoloExcluir,
  visualizarProtocolo,
  toastr: toastrReducer,
  form: formReducer,
  user,
  cockpit,
  recepcaoContratos,
  usuariosPreparacao,
  cadastrarCaixaReducer,
});
